const paths = {
  dashboard: '/',
  admin: '/admin',
  adminAuditLogs: '/admin/audit-logs',
  adminApprovalRoutes: '/admin/feed-reset-approval-routes',
  feeds: '/feeds',
  feedDetails: '/feeds/:id/',
  feedDetailsActions: (id: string) => `/feeds/${id}/actions`,
  feedDetailsOverview: (id: string) => `/feeds/${id}/overview`,
  feedDetailsProducts: (id: string) => `/feeds/${id}/products`,
  feedDetailsConnectTemplates: (id: string) => `/feeds/${id}/connect-templates`,
  feedDetailsConnectTemplatesNew: (id: string) =>
    `/feeds/${id}/connect-templates/new`,
  feedDetailsConnectTemplatesEdit: (id: string, templateId: string) =>
    `/feeds/${id}/connect-templates/${templateId}/edit`,
  feedDetailsConnectTemplatesView: (id: string, templateId: string) =>
    `/feeds/${id}/connect-templates/${templateId}/view`,
  feedDetailsAuditLogs: (id: string) => `/feeds/${id}/audit-logs`,
  feedDetailsPurposeSettings: (id: string) => `/feeds/${id}/purpose-settings`,
  login: '/login',
  documentation: '/documentation/*',
  createPurpose: '/create-purpose',
  extractList: '/extracts',
  extracts: '/extracts/*',
};

export default paths;
